/**
 * Created by Administrador on 11/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('operationService', operationService);

    operationService.$inject = ['$http', 'CONFIG', 'messageService'];

    function operationService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/operations';
        var service = {
            getOperations: getOperations,
            getOperation: getOperation,
            updateOperation: updateOperation,
            getOperationByCode: getOperationByCode
        }

        return service;

        function getOperations(onlyPenalties){
            var params = (onlyPenalties != undefined) ? "?onlyPenalties=" + onlyPenalties : "?onlyPenalties=false";
            return $http.get(urlBase + params)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.operations : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getOperation(id){
            return $http.get(urlBase + '/'+ id)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateOperation(id, operation){
            return $http.put(urlBase + '/'+ id, operation)
                .then(function(response){
                    messageService.registerUpdate('penalties')
                })
                .catch(function(){
                    messageService.registerUpdateError('penalties');
                });
        }

        function getOperationByCode(code){
            return $http.get(urlBase + '/code/'+ code)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    };

})();
